module.exports = "/_next/static/images/hacker-3b5792dd25274e441852819a0bea355b.png";